module.exports = __webpack_public_path__ + "media/images/strategic-partners/medcurity-2b99aecb71772f632b0365fc2ea1997c.jpeg";